import { render, staticRenderFns } from "./c_status.vue?vue&type=template&id=511e2a30&scoped=true&"
import script from "./c_status.vue?vue&type=script&lang=js&"
export * from "./c_status.vue?vue&type=script&lang=js&"
import style0 from "./c_status.vue?vue&type=style&index=0&id=511e2a30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511e2a30",
  null
  
)

export default component.exports